import 'core-js/modules/es.object.assign.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useUtility, Stack, shape, Text } from '@hub-la/design-system';
import { AssetStatus } from '@hub-la/fe-asset';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';

/** @description We should display this fallback when video that is still being processed by Mux */
const VideoProcessingCover = ({
  cover
}) => {
  const {
    palette
  } = useUtility();
  if ((cover === null || cover === void 0 ? void 0 : cover.status) !== AssetStatus.processing) {
    return null;
  }
  return jsxs(Stack, Object.assign({
    "data-testid": "video-is-processing",
    position: "relative",
    height: "100%",
    style: {
      backgroundColor: palette('surface')
    },
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center"
  }, {
    children: [jsx(Stack, Object.assign({
      style: {
        backgroundColor: palette('surfaceVariant')
      },
      width: 88,
      height: 88,
      justifyContent: "center",
      alignItems: "center",
      borderRadius: shape('full')
    }, {
      children: jsx(ErrorOutlineOutlinedIcon, {
        sx: {
          fontSize: 42
        }
      })
    })), jsxs(Text, Object.assign({
      color: "onSurfaceVariant",
      textAlign: "center",
      marginTop: 22
    }, {
      children: ["V\u00EDdeo ainda est\u00E1 sendo processado para uma melhor qualidade.", jsx("br", {}), " Isso pode levar alguns minutos."]
    }))]
  }));
};

export { VideoProcessingCover };
